<template>
  <div class="stake-stats">
    <div class="d-flex align-center justify-space-between">
      <div class="text-4">Proof-Of-Stake Stats</div>
      <div class="text-6">
        <span class="gray--text">Validator:</span>
        <a
          class="ml-1 darkgray--text font-weight-medium text-decoration-none"
          target="_blank"
          rel="noopener noreferrer"
          href="https://stakewith.us"
          >Stakewith.Us</a
        >
      </div>
    </div>
    <div class="mt-6">
      <stake-table :stakeItems="stakeItems" class="d-none d-md-block" />
      <stake-list-mobile :stakeItems="stakeItems" class="d-block d-md-none" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import BN from "bignumber.js";
import { projectMapEco } from "@/common/config/ecosystems";
import StakeTable from "./StakeTable.vue";
import StakeListMobile from "./StakeListMobile.vue";

export default {
  components: {
    StakeTable,
    StakeListMobile,
  },
  computed: {
    ...mapGetters({
      getTokenPriceInUsd: "appConfig/getTokenPriceInUsd",
      historicalVolume: "productStats/historicalVolume",
      votingPowers: "productStats/votingPowers",
      apys: "productStats/apys",
      ethereumProjects: "projectConfig/ethereumStakingProjects",
      tendermintProjects: "projectConfig/tendermintStakingProjects",
      solanaStakingProjects: "projectConfig/solanaStakingProjects",
      suiStakingProjects: "projectConfig/suiStakingProjects",
    }),
    stakeItems() {
      const data = [];
      const projects = [
        ...this.ethereumProjects,
        ...this.solanaStakingProjects,
        ...this.suiStakingProjects,
        ...this.tendermintProjects,
      ];
      const totalStakedRaw = this.historicalVolume.result?.rawData || {};
      const stakeApys = {
        ...this.apys.stake.tendermint,
        ...this.apys.stake.ethereum,
        ...this.apys.stake.sui,
        ...this.apys.stake.solana,
      };
      projects.forEach(item => {
        const tokenPrice = this.getTokenPriceInUsd(item.staking.token);
        const todayAum = totalStakedRaw[item.projectName]?.[0]?.value || 0;
        const yesterdayAum = totalStakedRaw[item.projectName]?.[1]?.value || 0;
        data.push({
          token: item.staking.token,
          tokenName: item.staking.token,
          name: item.text,
          projectName: item.name,
          status: item.status,
          tokenPrice,
          uptime: 100,
          variesApy: item.variesApy,
          votingPower: this.votingPowers.result?.[item.projectName] || {},
          totalStakedAUM: new BN(todayAum).multipliedBy(tokenPrice).toNumber(),
          balanceChange24h: {
            totalStakedAUM: {
              value: new BN(todayAum)
                .minus(yesterdayAum)
                .multipliedBy(tokenPrice)
                .toNumber(),
              percentage: new BN(todayAum)
                .minus(yesterdayAum)
                .dividedBy(yesterdayAum || 1)
                .multipliedBy(100)
                .toNumber(),
            },
          },
          yield3Days: {
            apy:
              (stakeApys[item.name] || stakeApys[item.projectName])?.apy *
                100 || 0,
          },
          yield15Days: {
            apy:
              (stakeApys[item.name] || stakeApys[item.projectName])?.apy *
                100 || 0,
          },
          market: projectMapEco[item.config.network],
        });
      });
      return data;
    },
  },
  mounted() {
    this.$store.dispatch("productStats/fetchStakeStats");
    this.$store.dispatch("productStats/fetchVotingPowers");
  },
};
</script>
